import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

/**
 * AppBar user name + role. Role uses a high-contrast chip so it stays
 * readable across theme palettes (secondary text on primary AppBar fails often).
 */
export default function AppBarUserMeta({ user }) {
  if (!user) return null;

  const name = user.displayName || user.email || 'Account';
  const role = user.role || 'Unknown';

  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'flex' },
        alignItems: 'center',
        gap: 1,
        mr: 1,
        minWidth: 0,
        flexShrink: 0,
      }}
    >
      <Typography
        variant="body2"
        noWrap
        sx={{
          color: 'inherit',
          fontWeight: 500,
          opacity: 0.95,
          maxWidth: { xs: 100, sm: 180 },
        }}
      >
        {name}
      </Typography>
      <Chip
        size="small"
        label={role}
        sx={{
          height: 24,
          fontWeight: 700,
          fontSize: '0.7rem',
          letterSpacing: '0.02em',
          bgcolor: 'rgba(255,255,255,0.94)',
          color: 'var(--color-text-primary, #2F303E)',
          border: '1px solid rgba(0,0,0,0.14)',
          '& .MuiChip-label': { px: 1 },
        }}
      />
    </Box>
  );
}
